"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    promoButtonEmphasisValues: ()=>promoButtonEmphasisValues,
    promoButtonPaletteValues: ()=>promoButtonPaletteValues,
    promoButtonVariants: ()=>promoButtonVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const promoButtonVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        rootSlot: 'flex items-center rounded-2xl px-3 py-2 gap-2 cursor-pointer border',
        iconWrapperSlot: 'flex items-center justify-center h-5 w-5 shrink-0',
        textIconGroupSlot: 'flex items-center gap-2',
        textContentSlot: 'flex-1 text-left break-words max-w-3xl text-body3',
        actionTextSlot: 'shrink-0 font-semibold text-body3'
    },
    variants: {
        palette: {
            primary: {}
        },
        emphasis: {
            regular: {},
            medium: {},
            bold: {}
        }
    },
    compoundVariants: [
        {
            palette: 'primary',
            emphasis: [
                'regular',
                'medium'
            ],
            class: {
                rootSlot: 'bg-primary-3 border-primary-7 text-primary-13 hover:bg-primary-4 hover:border-primary-8 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-8',
                iconWrapperSlot: 'text-primary-8 hover:text-primary-9',
                actionTextSlot: 'text-primary-8'
            }
        },
        {
            palette: 'primary',
            emphasis: 'bold',
            class: {
                rootSlot: 'bg-primary-8 border-primary-8 text-primary-1 hover:bg-primary-9 hover:border-primary-9 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-9',
                iconWrapperSlot: 'text-primary-1 hover:text-primary-1',
                actionTextSlot: 'text-primary-1'
            }
        }
    ],
    defaultVariants: {
        palette: 'primary',
        emphasis: 'regular'
    }
});
const promoButtonEmphasisValues = Object.keys(promoButtonVariants.variants.emphasis);
const promoButtonPaletteValues = Object.keys(promoButtonVariants.variants.palette);
exports.promoButtonEmphasisValues = __webpack_exports__.promoButtonEmphasisValues;
exports.promoButtonPaletteValues = __webpack_exports__.promoButtonPaletteValues;
exports.promoButtonVariants = __webpack_exports__.promoButtonVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "promoButtonEmphasisValues",
    "promoButtonPaletteValues",
    "promoButtonVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
